import { render } from "./SettingsPanel.vue?vue&type=template&id=65930c1f&scoped=true"
import script from "./SettingsPanel.vue?vue&type=script&lang=js"
export * from "./SettingsPanel.vue?vue&type=script&lang=js"

import "./SettingsPanel.vue?vue&type=style&index=0&id=65930c1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65930c1f"]])

export default __exports__